class JoliToc {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const toc = '.wpj-jtoc';
    const tocWrap = '.wpj-jtoc--toc';
    const openH = $(tocWrap).outerHeight();
    const tocToggle = '.wpj-jtoc--toggle-icon';
    $(tocToggle).append('<div class="js-add-cross"></div>');
    $(tocToggle).on('click', function () {
      if ($(toc).hasClass('is-active')) {
        $(toc).css('max-height', '');
      } else {
        $(toc).css('max-height', openH);
      }
      $(toc).toggleClass('is-active');
    })
  }
}